import classNames from 'classnames';
import { css, styled } from 'css-literal-loader/styled';
import React from 'react';
import Transition from 'react-transition-group/Transition';
import Layout from '@4c/layout';

import bflyIcon from '../assets/bfly-icon-white.svg';
import { CONTACT_URL } from '../config';
import { AuthContext } from './AuthWrapper';
import Responsive from './Responsive';
import TurkeyBurgerMenu from './TurkeyBurgerMenu';

const styles = require('./Navbar-styles.module.scss');

const NavLink = styled('a', null, "NavLink", require("./Navbar-NavLink.module.scss"), "nav-link", "navLink");

const propTypes = {};

class Navbar extends React.Component {
  state = { menuOpen: false };

  handleMenuToggle = () => {
    this.setState(s => ({ menuOpen: !s.menuOpen }));
  };

  render() {
    return (
      <AuthContext.Consumer>
        {({ logout, tokenResponse }) => {
          const navItems = (
            <>
              <NavLink href="https://www.butterflynetwork.com/about">
                About
              </NavLink>
              <NavLink href={CONTACT_URL}>Support</NavLink>
              <NavLink href="https://www.butterflynetwork.com/press">
                Press
              </NavLink>
              <NavLink href="https://careers.smartrecruiters.com/4Catalyzer/butterfly-network">
                Careers
              </NavLink>
              <NavLink href="https://www.butterflynetwork.com/contact">
                Contact
              </NavLink>
              {tokenResponse && (
                <NavLink href="#" onClick={logout}>
                  Log out
                </NavLink>
              )}
            </>
          );

          return (
            <Layout className={styles.navbar} align="center">
              <a href="https://www.butterflynetwork.com">
                <img src={bflyIcon} alt="Home" />
              </a>
              <Layout.Spacer />
              <Responsive mdDown>
                <TurkeyBurgerMenu
                  in={this.state.menuOpen}
                  onClick={this.handleMenuToggle}
                />
              </Responsive>
              <div className={styles.collapse}>
                <Transition in={this.state.menuOpen} timeout={400}>
                  {state => (
                    <Layout className={classNames(styles.menu, styles[state])}>
                      {navItems}
                    </Layout>
                  )}
                </Transition>
              </div>
            </Layout>
          );
        }}
      </AuthContext.Consumer>
    );
  }
}

Navbar.propTypes = propTypes;

export default Navbar;
